export enum PRODUCT_ACTION_TYPES {
  FETCH_ALL_DATA = "product/FETCH_ALL_DATA",
  UPDATE_PRODUCT = "product/UPDATE_PRODUCT",
  RELATED_CATEGORY_DATA = "product/RELATED_CATEGORY_DATA",
  UPDATE_EDIT_PRODUCT = "product/UPDATE_EDIT_PRODUCT",
  UPLOAD_PRODUCT = "product/UPLOAD_PRODUCT",
  UPDATE_PRODUCT_ATTRIBUTES = "product/UPDATE_PRODUCT_ATTRIBUTES",
  DELETE_PRODUCTS = "product/DELETE_PRODUCTS",
}
